import { render, staticRenderFns } from "./PlatformRatting.vue?vue&type=template&id=377415ab"
import script from "./PlatformRatting.vue?vue&type=script&lang=js"
export * from "./PlatformRatting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports